export const IMS_UNLIMITED_AMOUNT = '92233720368547758.07';

export const UNLIMITED_AMOUNT = Number(IMS_UNLIMITED_AMOUNT);
